export var VERSION = "1.3.31";
//# sourceMappingURL=version.js.map